import { useCallback, useState } from "react";
// import { Handle, Position } from "reactflow";

// const handleStyle = { left: 10 };

function StatusNode({ data, isConnectable }) {
  const [isVerificationOption, setIsVerificationOption] = useState(false);
  const [isVerificationContacts, setIsVerificationContacts] = useState(false);
  const [isDiscussion, setDiscussion] = useState(false);
  const [isDiscussionOption, setIsDiscussionOption] = useState(false);
  const [isDiscussionContacts, setDiscussionContacts] = useState(false);
  const [isVerificationCall, setVerificationCall] = useState(false);
  const [isVerificationEmail, setVerificationEmail] = useState(false);

  const handleContacts = () => {
    setIsVerificationContacts(!isVerificationContacts);
  };

  const handleVerificationCall = () => {
    handleContacts();
    setVerificationCall(true);
  };

  const handleVerificationEmail = () => {
    handleContacts();
    setVerificationEmail(true);
  };

  return (
    <div className="text-updater-node" style={{ width: "100%" }}>
      <div className="w-[13rem] h-[10vh] relative flex items-start justify-start">
        <div className="text-[6px] text-[#BDBDBD] mt-2 mr-2">Status 1</div>
        <div className=" text-center bg-[#F8F8F8] p-1 py-2 rounded-md cursor-pointer relative w-[8rem]">
          <p className="text-[8px] font-bold">Verification</p>
          <div className="absolute -right-1 top-2 w-3">
            <p
              className="bg-[#D4F0FF] rounded-full text-[10px]"
              onClick={() => setIsVerificationOption(!isVerificationOption)}
            >
              +
            </p>
          </div>
          <div
            className="absolute left-16 bg-[#8282823e] rounded-full w-3 text-center mt-1"
            onClick={handleContacts}
          >
            <p className="text-[10px]">+</p>
          </div>
        </div>

        {isVerificationOption ? (
          <div className="absolute right-0 mt-2 w-[3rem]">
            <div
              className="bg-[#D4F0FF] rounded-lg p-1 text-[8px] text-center"
              onClick={() => setDiscussion(true)}
            >
              Discussion
            </div>
            <div className="bg-[#D4F0FF] rounded-lg p-1 text-[8px] mt-1 text-center">
              Negotiation
            </div>
            <div className="bg-[#D4F0FF] rounded-lg p-1 text-[8px] mt-1 text-center">
              Won/Loss
            </div>
          </div>
        ) : (
          ""
        )}

        {isVerificationContacts ? (
          <div className="absolute left-14 ml-8 top-8 mt-2">
            <div
              className="bg-[#F9F5E3] border rounded-lg py-[2px] w-[2rem] text-[8px] text-center"
              onClick={handleVerificationCall}
            >
              Call
            </div>
            <div
              className="bg-[#F9F5E3] border rounded-lg py-[2px] w-[2rem] text-[8px] mt-1 text-center"
              onClick={handleVerificationEmail}
            >
              Email
            </div>
            <div className="bg-[#F9F5E3] border rounded-lg w-[3rem] py-[2px] text-[8px] mt-1 text-center">
              Message
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {isVerificationCall ? (
        <div className="bg-[#F9F5E3] border border-[#FFBF1A] rounded-lg py-[2px] w-[2rem] text-[8px] flex justify-center items-center">
          <p>Call</p>
          <span className="ml-1" onClick={() => setVerificationCall(false)}>
            &#xd7;
          </span>
        </div>
      ) : (
        ""
      )}
      {isVerificationEmail ? (
        <div>
          <div className="absolute h-10 w-[1rem] text-black"></div>
          <div className="bg-[#F9F5E3] border border-[#FFBF1A] rounded-lg py-[2px] w-[2.5rem] text-[8px] mt-1 flex justify-center items-center">
            <p>Email</p>
            <span className="ml-1" onClick={() => setVerificationEmail(false)}>
              &#xd7;
            </span>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* second */}
      {isDiscussion ? (
        <div className="mt-8 w-[13rem] h-[10vh] relative flex items-start justify-start">
          <div className="text-[6px] text-[#BDBDBD] mt-2 mr-2">Status 2</div>
          <div className=" text-center bg-[#F8F8F8] p-1 py-2 rounded-md cursor-pointer relative w-[8rem]">
            <p className="text-[8px] font-bold">Discussion</p>
            <div className="absolute -right-1 top-2 w-3">
              <p
                className="bg-[#D4F0FF] rounded-full text-[10px]"
                onClick={() => setIsDiscussionOption(!isDiscussionOption)}
              >
                +
              </p>
            </div>
            <div
              className="absolute left-16 bg-[#8282823e] rounded-full w-3 text-center mt-1"
              onClick={() => setDiscussionContacts(!isDiscussionContacts)}
            >
              <p className="text-[10px]">+</p>
            </div>
          </div>

          {isDiscussionOption ? (
            <div className="absolute right-0 mt-2 w-[3rem]">
              <div className="bg-[#D4F0FF] rounded-lg p-1 text-[8px] text-center">
                Discussion
              </div>
              <div className="bg-[#D4F0FF] rounded-lg p-1 text-[8px] mt-1 text-center">
                Negotiation
              </div>
              <div className="bg-[#D4F0FF] rounded-lg p-1 text-[8px] mt-1 text-center">
                Won/Loss
              </div>
            </div>
          ) : (
            ""
          )}

          {isDiscussionContacts ? (
            <div className="absolute left-14 ml-8 top-8 mt-2">
              <div className="bg-[#F9F5E3] border rounded-lg py-[2px] w-[2rem] text-[8px] text-center">
                Call
              </div>
              <div className="bg-[#F9F5E3] border rounded-lg py-[2px] w-[2rem] text-[8px] mt-1 text-center">
                Email
              </div>
              <div className="bg-[#F9F5E3] border rounded-lg w-[3rem] py-[2px] text-[8px] mt-1 text-center">
                Message
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default StatusNode;

//   const onChange = useCallback((evt) => {
//     console.log(evt.target.value);
//   }, []);

{
  /* <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        style={{ background: '#555' }}
      /> */
}

{
  /* <Handle
        type="source"
        position={Position.Bottom}
        id="a"
        style={handleStyle}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="b"
        isConnectable={isConnectable}
      /> */
}
